import { ComponentBlock } from '@types';

import { types } from 'core/types';

import { component } from './component';
import { InputProps, InputTriggers } from './index';

export const block: ComponentBlock<'input', InputProps, InputTriggers> = {
  id: 'input',
  render: component,
  props: {
    name: {
      type: types.string,
    },
    value: {
      type: types.string,
    },
    label: {
      type: types.string,
    },
    placeholder: {
      type: types.string,
    },
    size: {
      type: types.string,
    },
  },
  triggers: {
    onBlur: {
      name: 'On blur',
      description: 'When the control is unfocused',
    },
  },
};
